<template>
  <!--Extras Case-1-->
  <div
    id="modalExtrasExcluded"
    class="modal s-modal s-modal--warning"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-warning"></i></div>
            <div>{{ dictionary.modalExtrasTitle }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ dictionary.modalExtrasExcludedText }}</p>

          <ul class="b-extras-as-badges-list">
            <li v-for="(child, index) in childs" :key="index">
              <div class="e-extra-as-badge">{{ child }}</div>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <ul>
            <li>
              <button
                type="button"
                class="btn btn-primary btn-full-width"
                data-bs-dismiss="modal">
                {{ dictionary.modalExtrasExcludedButtonCancelText }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    childs: {
      required: false,
      type: Array,
      default: () => [],
    },
  },
}
</script>
